export default __webpack_public_path__ + "static/media/hero-animation-02.faec65ce.svg";